import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DialogActions, DialogContent, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { LocaleContext } from "../../../routing/LangRouter";

//import redux store
import { saveFlightData, saveHotelData, saveHotelSelectedFilters, saveIntFlightData, saveTicketSelectedFilters } from "../../../store/actions";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import BaseTitle from "../base-title/base-title";
import BaseDialog from "../base-dialog/base-dialog";

//import view components
import SelectedTicket from "./selected-ticket";
import SelectedHotel from "./selected-hotel";
import ActionButton from "./action-button";

//import images and icons
import { ArrowLeft, ArrowLeft2 } from "iconsax-react";

//import styled
import "./selected-item.scss";

function SelectedItem({ dispatch, data: { title, star, name, image, date, totalPrice, type, details, route } }) {
    //general variables
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation"));

    const [isDetailsOpen, setIsDetailsOpen] = useState(false);

    //handle change ticket and hotel
    const handleRemove = () => {
        //items to remove from sessionStorage
        const flightSessionItems = ["selectedIntFlight", "selectedFlight", "flightPassengers", "intFlightPassengers"];
        const hotelSessionItems = ["selectedHotel", "selectedRooms", "selectedIntRooms", "hotelPassengers", "intHotelPassengers"];

        //remove items from sessionStorage
        (type === "flight" || type === "intFlight" ? flightSessionItems : hotelSessionItems).forEach(item => {
            sessionStorage.removeItem(item);
        });

        //redux actions to reset
        const flightResetActions = [saveTicketSelectedFilters, saveIntFlightData, saveFlightData];
        const hotelResetActions = [saveHotelSelectedFilters, saveHotelData];

        //dispatch each with null
        (type === "flight" || type === "intFlight" ? flightResetActions : hotelResetActions).forEach(action => {
            dispatch(action(null));
        });

        if (type === "flight") {
            sessionStorage.setItem("domesticFlightInformation", JSON.stringify(domesticFlightInformation));
        }

        //navigate to the route
        if (isItinerary) {
            navigate({ pathname: `/${locale}/itinerary/${route}` }, { replace: true });
        } else {
            navigate({ pathname: `/${locale}/${route}` }, { replace: true });
        }
    };

    return (
        <Grid container item xs={12}>
            <BaseTitle title={t("General.Your Choice")} dividerColor="1px solid var(--medium-gray-color)" />

            {IS_MOBILE ? (
                <Grid className="selected-item" container item xs={12} rowGap={1}>
                    <Grid className="selected-item__title" container item xs="auto">
                        {title}
                    </Grid>
                    <Grid className="selected-item__information" container item xs={12} justifyContent="space-between" alignItems="center">
                        <Grid container item xs={9}>
                            <Grid component="span" container item xs={12} columnGap={1} wrap="nowrap">
                                {name.map(item => {
                                    return (
                                        <Grid
                                            key={Math.random()}
                                            className="selected-item__name"
                                            container
                                            item
                                            xs="auto"
                                            columnGap={1}
                                            alignItems="center"
                                        >
                                            {item}{" "}
                                            {type !== "hotel" && name.indexOf(item) !== name.length - 1 && (
                                                <ArrowLeft size="16" color="var(--teal-color-18)" />
                                            )}
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <Grid className="selected-item__date" component="span" container item xs={12}>
                                {date}
                            </Grid>
                        </Grid>
                        <Grid className="selected-item__details-button" container item xs="auto" onClick={() => setIsDetailsOpen(true)}>
                            {t("General.Details")} <ArrowLeft2 size="18" color="var(--primary-color)" />
                        </Grid>
                    </Grid>
                </Grid>
            ) : (
                <>
                    {(type === "intFlight" || type === "flight") && (
                        <SelectedTicket type={type} selectedFlight={details} handleRemoveTicket={handleRemove} />
                    )}

                    {(type === "hotel" || type === "intHotel") && (
                        <SelectedHotel {...{ title, star, image, selectedRoom: details, date, totalPrice, type, handleRemoveHotel: handleRemove }} />
                    )}
                </>
            )}

            <BaseDialog title={t("details")} open={isDetailsOpen} handleClose={() => setIsDetailsOpen(false)} top="0" icon="close">
                <DialogContent dividers={true}>
                    {(type === "intFlight" || type === "flight") && (
                        <SelectedTicket type={type} selectedFlight={details} handleRemoveTicket={handleRemove} />
                    )}

                    {(type === "hotel" || type === "intHotel") && (
                        <SelectedHotel {...{ title, star, image, selectedRoom: details, date, totalPrice, type, handleRemoveHotel: handleRemove }} />
                    )}
                </DialogContent>
                <DialogActions>
                    <ActionButton
                        text={type === "flight" || type === "intFlight" ? t("remove") : t("editHotel")}
                        price={details?.fares?.total_price || details?.departure?.totalPrice || 0 || totalPrice}
                        handleRemove={handleRemove}
                    />
                </DialogActions>
            </BaseDialog>
        </Grid>
    );
}

export default connect()(SelectedItem);
